import React from 'react'
import styled from 'styled-components'
import Header from './header'

const Wrapper = styled.div`
  display: block;
  position: relative;
  flex-direction: column;
  flex: 1 1 auto;
  border: auto;

  .button-wrapper {
    align-items: center !important;
  }

  .inner {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);

    @media (max-width: 768px) {
      .content .top {
        display: flex;
        flex-direction: column;
        text-align: center;
      }
      .content .button-wrapper {
        margin: 0 auto;
        display: flex;
        max-width: 100px;
      }
    }
  }

  @media (max-width: 768px) {
    margin: 0;
    padding: 30px 0 0;
  }

  .loader-wrapper {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 50px;
  }
`

export default function Card({
  title,
  subTitle,
  className,
  button,
  children,
  style = {},
}: {
  title?: string | null
  subTitle?: string | null
  className?: string
  button?: any
  children?: any
  autoSpace?: boolean
  style?: any
}) {
  const hasHeaderCard = title || subTitle

  return (
    <Wrapper
      className={className}
      role='row'
      style={{
        ...style,
        overflow: 'visible',
      }}
    >
      <div className='inner'>
        {hasHeaderCard ? (
          <Header
            title={title ? title : ''}
            subtitle={subTitle ? subTitle : ''}
            extraButtons={button}
          />
        ) : null}
        {children}
      </div>
    </Wrapper>
  )
}
